import React, { cloneElement } from 'react';
import {
    List, Datagrid, TextField, Create, SimpleForm, TextInput, Edit, EditButton, SaveButton, Toolbar, CreateButton, TopToolbar,
    DeleteButton, FunctionField, ReferenceInput, AutocompleteInput, useListContext, downloadCSV, sanitizeListRestProps, useRedirect
} from 'react-admin';
import { IconButton, withStyles, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link } from "react-router-dom";
import moment from "moment";
import jsonExport from 'jsonexport/dist';
import CustomExportButton from "./components/CustomExportButton";
import DataProvider from "./dataProvider";
import queryString from 'query-string';
import config from './config.json';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';

const ListActions = (props) => {
    //const notify = useNotify();

    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;

    const {
        currentSort,
        resource,
        displayedFilters,
        filter,
        filterValues,
        basePath,
        showFilter,
        total
    } = useListContext();

    const getCSV = () => {
        DataProvider.getList(resource, { pagination: { page: 1, perPage: 1000 }, sort: currentSort, filter: { enabled: 1, ...filterValues } }).then(response => {
            const records = response.data;
            const data = records.map(record => ({
                name: record.name,
                mobile_number: record.mobile_number,
                vehicle_number: record.vehicle_number,
                vehicle_model: record.vehicle_model,
                registration_date: record.registration_date,
                address: record.address,
                rfid: record.rfid,
                serial_number: record.serial_number,
            }));
            jsonExport(data, {
                headers: ['name', 'mobile_number', 'vehicle_number', 'vehicle_model', 'registration_date', 'address', 'rfid', 'serial_number'],
            }, (err, csv) => {
                ;
                downloadCSV(csv, 'RFIDs');
            });
        });
    };

    const getPDF = () => {
        const params = {
            filter: JSON.stringify({ ...filter, ...filterValues }),
            sort: JSON.stringify([currentSort.field, currentSort.order]),
            page: 1,
            perPage: total,
            user_id: sessionStorage.getItem("user_id")
        };
        fetch(`${config.HOST_NAME}/crm/v3/rfids?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                'Accept': `application/pdf`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.blob()
            })
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const tempLinkElement = document.createElement('a');
                tempLinkElement.href = url;
                tempLinkElement.setAttribute('download', `RFIDs`);
                tempLinkElement.click();
            })
            .catch(error => {
                notify('Error Exporting Data', 'warning');
            });
    };

    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
            <CustomExportButton getCSV={getCSV} getPDF={getPDF} style={{ alignSelf: "flex-start" }} />
        </TopToolbar>
    );
};

export const RfidList = props => (
    <List
        {...props}
        title="RFID"
        bulkActionButtons={false}
        filter={{ enabled: 1 }}
        sort={{ field: 'registration_date', order: 'DESC' }}
        actions={<ListActions />}
        empty={false}
    >
        <Datagrid classes={{ rowCell: "RfidRowCell" }}>
            <TextField source="name" label="Name" />
            <TextField source="mobile_number" label="Mobile Number" />
            <TextField source="vehicle_number" label="Vehicle" />
            <TextField source="vehicle_model" label="Vehicle Model" />
            <FunctionField label="Register Date" render={record => moment(record["registration_date"], "YYYY-MM-DD HH:mm:ss").format("MMM Do, YYYY hh:mm a")} />
            {/* <FunctionField label="Address" render={record => record["address"] && record["address"].length > 40 ? record["address"].substr(0, 37) + "..." : record["address"] } /> */}
            <TextField source="address" label="Address" />
            <TextField source="rfid" label="RFID No." />
            <TextField source="serial_number" label="Serial Number" />
            <EditButton />
            <DeleteButton undoable={false} label="" className="DeleteButton" />
        </Datagrid>
    </List>
);

const validateUserCreation = (values) => {
    const errors = {};
    if (!values.reference_id || values.reference_id === "") {
        errors.reference_id = 'RFID is required';
    }

    if (!values.name || values.name === "") {
        errors.name = 'User Name is required';
    } else if (values.name.length > 30) {
        errors.name = 'Name too long';
    }

    if (!values.mobile_number || values.mobile_number === "") {
        errors.mobile_number = 'Mobile Number is required';
    } else if (values.mobile_number.length !== 10 || isNaN(values.mobile_number)) {
        errors.mobile_number = 'Invalid Mobile Number';
    }

    if (!values.vehicle_number || values.vehicle_number === "") {
        errors.vehicle_number = 'Vehicle Number is required';
    } else if (values.vehicle_number.length > 20) {
        errors.vehicle_number = 'Vehicle Number too long';
    }

    if (!values.vehicle_model || values.vehicle_model === "") {
        errors.vehicle_model = 'Vehicle Mobdel is required';
    } else if (values.vehicle_model.length > 100) {
        errors.vehicle_model = 'Vehicle Model too long';
    }

    if (!values.address || values.address === "") {
        errors.address = 'Address is required';
    } else if (values.address.length > 500) {
        errors.address = 'Address too long';
    }

    return errors;
};

export const RfidCreate = ({ permissions, ...props }) => {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Create {...props} onFailure={onFailure} onSuccess={onSuccess} title="Create RFID">
            <SimpleForm validate={validateUserCreation} redirect="list">
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    borderBottom: "1px solid #ddd",
                    alignItems: "center",
                    paddingBottom: 4,
                    marginBottom: 10
                }}>
                    <IconButton component={Link} to="/rfids"><ArrowBackIcon /></IconButton>
                    <Typography>CREATE RFID</Typography>
                    <div style={{ width: 70 }}></div>
                </div>
                <ReferenceInput label="RFID No." source="reference_id" reference="rfids" perPage={1000}>
                    <AutocompleteInput optionText="rfid" />
                </ReferenceInput>
                <TextInput source="name" label="Name" />
                <TextInput source="mobile_number" label="Mobile Number" />
                <TextInput source="vehicle_number" label="Vehicle Number" />
                <TextInput source="vehicle_model" label="Vehicle Model" />
                <TextInput source="address" label="Address" multiline rowsMax={4} />
            </SimpleForm>
        </Create>
    )
};

const validateUserEdit = (values) => {
    const errors = {};
    if (!values.name || values.name === "") {
        errors.name = 'User Name is required';
    } else if (values.name.length > 30) {
        errors.name = 'Name too long';
    }

    if (!values.vehicle_model || values.vehicle_model === "") {
        errors.vehicle_model = 'Vehicle Mobdel is required';
    } else if (values.vehicle_model.length > 100) {
        errors.vehicle_model = 'Vehicle Model too long';
    }

    if (!values.address || values.address === "") {
        errors.address = 'Address is required';
    } else if (values.address.length > 500) {
        errors.address = 'Address too long';
    }

    return errors;
};

const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

const CustomToolbar = withStyles(toolbarStyles)(props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
));

export const RfidEdit = ({ permissions, ...props }) => {
    const redirect = useRedirect();
    const onSuccess = () => {
        notify("Element Updated", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (
        <Edit title='Edit RFID' {...props} onFailure={onFailure} onSuccess={onSuccess} undoable={false}>
            <SimpleForm redirect="list" validate={validateUserEdit} toolbar={<CustomToolbar />}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    borderBottom: "1px solid #ddd",
                    alignItems: "center",
                    paddingBottom: 4,
                    marginBottom: 10
                }}>
                    <IconButton component={Link} to="/rfids"><ArrowBackIcon /></IconButton>
                    <Typography>EDIT RFID</Typography>
                    <div style={{ width: 70 }}></div>
                </div>
                <TextInput source="name" label="Name" />
                <TextInput source="vehicle_model" label="Vehicle Model" />
                <TextInput source="address" label="Address" multiline />
            </SimpleForm>
        </Edit>
    )
};